import { motion } from "framer-motion";
import { ShieldCheck, FileCheck, Lock, Building2 } from "lucide-react";

const trustItems = [
  { icon: Building2, title: "UK Incorporated", description: "AdV3nture is a UK-registered company operating within established regulatory frameworks." },
  { icon: FileCheck, title: "Identity Verification (KYC)", description: "Identity verification for founders and investors using Stripe’s trusted verification infrastructure." },
  { icon: Lock, title: "Secure Infrastructure", description: "Encrypted data handling and secure platform infrastructure." },
  { icon: ShieldCheck, title: "Compliance by Design", description: "Regulatory considerations built into the platform architecture from day one." },
];

const TrustSection = () => {
  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            Trust & <span className="text-gradient">Compliance</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Security and compliance are foundational, not optional.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {trustItems.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass rounded-xl p-6 text-center"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary mb-4">
                <item.icon className="w-6 h-6" />
              </div>
              <h3 className="font-display font-semibold mb-2 text-sm">{item.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
